// colors for marking different transfer integrals 
const ExchangeColors = [
    "#de3163",
    "#FF7F50",
    "#f4e604",
    "#a7e237",
    "#37bd79", 
    "#308fac",
    "#0457ac",
    "#000080",
    "#800080",
    "#C0C0C0",
    "#e6c5bf",
    "#c2a594",
    "#93a197",
    "#6c7a85",
    "#4faea5",
    "#4cb7ad",
    "#4fa59d",
    "#5db7ae",
    "#3e968e"
];

export default ExchangeColors;